import React from 'react'
import FilterListIcon from '@material-ui/icons/FilterList'
import { useTranslation } from 'react-i18next'
import { useFilterOpenButtonStyles } from './filter-open-button.styles'

type FilterOpenButtonProps = {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void | undefined
}

export const FilterOpenButton: React.FC<FilterOpenButtonProps> = ({
  onClick,
}) => {
  const classes = useFilterOpenButtonStyles()
  const { t } = useTranslation()

  return (
    <button
      type="button"
      className={classes.root}
      onClick={onClick}
      aria-label={t('filter.open', 'Open filters')}
    >
      <FilterListIcon />
    </button>
  )
}
